import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { InfoOutlined } from '@mui/icons-material'
import styled from '@emotion/styled'
import { Collapse, IconButton, Tooltip, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { IContractItem } from 'types/contracts'
import { formatTimeStampToStandartDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'

const StyledTableCell = styled(TableCell)({
  fontSize: '14px !important',
})

function Row(props: { row: IContractItem }) {
  const { row } = props
  const [open, setOpen] = React.useState(false)
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <StyledTableCell>{row.issuerOrganizationName}</StyledTableCell>
        <StyledTableCell>{row.contractorOrganizationName}</StyledTableCell>
        <StyledTableCell>{row.taxId}</StyledTableCell>
        <StyledTableCell>{row.lotName}</StyledTableCell>
        <StyledTableCell>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Box>
        </StyledTableCell>
      </TableRow>
      <TableRow sx={{ padding: 0 }}>
        <TableCell style={{ padding: 0, background: '#fafbfb' }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ padding: '16px 20px' }}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('contract-amount')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {row.amount} AZN
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('procurementMethod')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {t(row.procurementMethod)}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('createdDate')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {row.contractStartDate
                      ? formatTimeStampToStandartDate(row.contractStartDate)
                      : '-'}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('endDate')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {row.contractEndDate
                      ? formatTimeStampToStandartDate(row.contractEndDate)
                      : '-'}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

type Props = {
  contracts: IContractItem[]
}

export function ConcludedContractsTable({ contracts }: Props) {
  const { t } = useTranslation()
  return (
    <Box sx={{ overflow: 'auto' }}>
      <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
        <TableContainer component={Box}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{t('tender-organization-name')}</TableCell>
                <TableCell>{t('winner-name')}</TableCell>
                <TableCell>{t('winner-tin')}</TableCell>
                <TableCell>{t('contestName')}</TableCell>
                <TableCell colSpan={2} />
              </TableRow>
            </TableHead>
            <TableBody>
              {contracts.map((row) => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
